import dynamic from 'next/dynamic';

import React from "react";
import Image from "next/image";
import { PortableText } from "@portabletext/react";
import { useAboutInfoData } from "@/hooks/useAboutInfoData";

const Button = dynamic(() => import('@/components/ui/Button'));

export default function InfoSection() {
  const aboutInfo = useAboutInfoData();

  if (!aboutInfo) {
    return null;
  }

  return (
    <>
      <section className="my-8">
        <div className="xl:container mx-auto flex flex-row items-center justify-between">
          <div className="flex-grow flex flex-col xl:items-start items-center text-center px-2">
            <div className="mb-12 leading-relaxed text-metaxseed-text-gray text-lg text-justify gothamBook">
              <PortableText value={aboutInfo.body ?? []} />
            </div>
            <div className="flex xl:justify-center w-full xl:w-auto">
              <a
                href={aboutInfo.ButtonLink}
                target="_blank"
                rel="noopener noreferrer"
                className="w-full xl:w-auto"
              >
                <Button
                  text={aboutInfo.ButtonText}
                  className="hover:jello-horizontal bg-metaxseed-blue h-min 2xl:text-lg gothamMedium font-normal text-base shadow-lg transition-all duration-300 ease-in-out w-full xl:w-auto"
                />
              </a>
            </div>
          </div>

          {aboutInfo.image?.url ? (
            <div className="lg:flex items-start ml-16 xl:ml-48 flex-grow hidden">
              <Image
                width={510}
                height={900}
                src={aboutInfo.image.url}
                alt={aboutInfo.imageAlt ?? ""}
                className="w-auto xl:transform xl:scale-[2] xl:translate-y-[-10rem] xl:z-10 xl:translate-x-[-4rem] max-w-52 opacity-65"
              />
            </div>
          ) : null}
        </div>
      </section>
    </>
  );
}
